import React from 'react';

interface LogoImageProps {
  className?: string;
  height?: string;
  showText?: boolean;
  textSize?: string;
}

const LogoImage: React.FC<LogoImageProps> = ({
  className = '',
  height = 'h-12',
  showText = true,
  textSize = 'text-lg'
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Image */}
      <img
        src="/ai-logo.png"
        alt="AI Performance Solutions"
        className={`${height} w-auto object-contain`}
      />

      {/* AI PERFORMANCE SOLUTIONS Text - Perfectly Aligned */}
      {showText && (
        <div className="ml-3 flex flex-col justify-center">
          <div className="flex flex-col leading-none">
            <span className={`font-bebas ${textSize} tracking-[0.12em] text-white leading-[0.9]`}>
              AI PERFORMANCE
            </span>
            <span className={`font-bebas ${textSize} tracking-[0.12em] text-primary leading-[0.9]`}>
              SOLUTIONS
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoImage;